import { render, staticRenderFns } from "./AppTextCard.vue?vue&type=template&id=7dcb251a&scoped=true"
import script from "./AppTextCard.vue?vue&type=script&lang=js"
export * from "./AppTextCard.vue?vue&type=script&lang=js"
import style0 from "./AppTextCard.vue?vue&type=style&index=0&id=7dcb251a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcb251a",
  null
  
)

export default component.exports